// extracted by mini-css-extract-plugin
export default {"item":"styles_item__CAkmJ","content":"styles_content__96pMd","socialButtonsContainer":"styles_socialButtonsContainer__U3JhD","socialButton":"styles_socialButton__eHolu"};